import axios, { AxiosInstance } from "axios";
import Settings from "src/settings/settings-class";

const API_URL = Settings.data.paymentsApiUrl;

export const getInstanceBackend = (): AxiosInstance => {
  return axios.create({
    baseURL: API_URL,
    timeout: 10000,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};
